var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { basesUrl } from '../hooks/useHttp';
const DEFAULT_ERROR_RESPONSE = {
    auth: false,
    type: 'error',
    message: 'Request failed',
    data: null
};
export const request = (url, method = 'GET', body = null, headers = {}) => __awaiter(void 0, void 0, void 0, function* () {
    if (body) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
        headers['Cache-Control'] = 'no-cache';
    }
    const res = yield fetch(basesUrl + url, { method, body, headers, credentials: 'include' });
    if (res.status === 401 || res.status === 303) {
        return Object.assign(Object.assign({}, DEFAULT_ERROR_RESPONSE), { message: 'Unauthorized' });
    }
    if (!res.ok) {
        throw new Error(`Server error: ${res.status}`);
    }
    try {
        return yield res.json();
    }
    catch (_a) {
        throw new Error('Failed to parse server response');
    }
});
